import {
  DGT_Pagination,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseData,
} from "./../../../utils/utils";

import { GridSortItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  GetAllVisitNoteTemplateTemplateTypeEnum,
  VisitNoteTemplateControllerApi,
} from "../../../services";
import { getConfigObject } from "../../../utils/utils";
import { useEncounterCreationGate } from "../../../hooks/use-encounter-creation-gate";

type Params = {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  archive?: boolean;
  searchString?: string;
  templateType?: GetAllVisitNoteTemplateTemplateTypeEnum;
  username?: string;
  xTENANTID?: string;
};

/**
 * @author [Rajkumar rathod]
 */
export const useVisitNoteTemplateGetAll = (
  params: Params
): useBaseData<any> => {
  const prevPage = useRef<number>(params?.pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination: params?.pagination,
    searchKey: params?.searchString,
    prevPage,
  });
  const pageSize = getPageSize(params?.searchString, params?.pagination);

  const sortData = params?.gridSorting?.[0];
  const skip = useEncounterCreationGate();

  return useQuery({
    queryKey: ["visit-note-template-get-all", params],
    enabled: !skip,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new VisitNoteTemplateControllerApi(getConfigObject())
        .getAllVisitNoteTemplate(
          pageIndex,
          pageSize,
          sortData?.sort ?? undefined,
          sortData?.field,
          params?.archive,
          params?.searchString,
          params?.templateType,
          params?.username,
          params?.xTENANTID
        )
        .then((res) => res?.data),
  });
};
